import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { ArrowLeft, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ROUTES } from 'constants/routes';

export const QuestionHeader = (): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.SERVICES);
  const navigate = useNavigate();

  return (
    <div className="flex items-center py-4 px-8 border-b border-t bg-white w-full">
      <Button variant="ghost" icon="only" onClick={() => navigate(ROUTES.SAPA)} className="mr-2">
        <ArrowLeft className="h-5 w-5" />
      </Button>
      <div className="flex items-center flex-1">
        <div className="h-10 w-10 rounded-full bg-red-600 flex items-center justify-center shrink-0">
          <Shield className="h-5 w-5 text-white" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium">{t('Sapa.heading')}</h3>
          <p className="text-xs text-gray-600">{t('Sapa.body')}</p>
        </div>
      </div>
    </div>
  );
};
